'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Clock = require('./Clock');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Clock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Clock/index.js
// module id = 1153
// module chunks = 1